import React from 'react';
import CalendarSelector from "../../components/home/CalendarSelector";
import { ModalCalendar } from "../../components/home/modal/ModalCalendar.modal";

export default function HomePage() {
  return (
    <>
      <CalendarSelector />
      <ModalCalendar />
    </>
  );
}
